module.exports = __webpack_public_path__ + "img/banner_ad.d03e5ab.webp";